import { Blocks, Layers, Target, TrendingUp } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Section, SectionHead } from "./Reveal";

const ICONS = { layers: Layers, blocks: Blocks, trend: TrendingUp, target: Target };

export const Consulting = () => {
  const { t } = useLang();

  return (
    <Section id="consultoria" className="bg-ink-900/40">
      <SectionHead label={t.consult.label} title={t.consult.heading} sub={t.consult.sub} />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {t.consult.cards.map((c, i) => {
          const Icon = ICONS[c.icon];
          return (
            <Reveal key={c.title} delay={(i % 4) * 0.06} className="h-full">
              <div
                data-testid={`consulting-card-${i + 1}`}
                className="group h-full rounded-xl border border-line bg-ink-950/80 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-volt/30 hover:bg-ink-800"
              >
                <Icon size={20} className="text-volt" />
                <h3 className="mt-6 font-display text-lg font-bold tracking-tight">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-mist">{c.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
